import { Badge, Box, Text } from '@chakra-ui/react'
import { sanitizeRestrictedLabelText } from '@/lib/utils/displayText'
import { getCsatScoreLabel } from '@/types/csat'

interface CsatScoreDisplayProps {
  score?: number | string | null
  scoreLabel?: string | null
  submittedAt?: string | null
  compact?: boolean
}

function formatSubmittedAt(iso: string): string {
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    })
  } catch {
    return iso
  }
}

export function CsatScoreDisplay({
  score,
  scoreLabel,
  submittedAt,
  compact = false,
}: CsatScoreDisplayProps) {
  const fallback = getCsatScoreLabel(score)
  const label =
    scoreLabel != null && String(scoreLabel).trim() !== ''
      ? sanitizeRestrictedLabelText(scoreLabel) || fallback
      : fallback
  const hasScore = label !== '—'

  return (
    <Box>
      <Text fontSize="xs" color="gray.500" mb={1.5}>
        CSAT Score
      </Text>
      {hasScore ? (
        <Badge colorScheme="yellow" fontSize={compact ? 'sm' : 'md'} px={2} py={1}>
          {label}
        </Badge>
      ) : (
        <Text fontSize="sm" color="gray.500">
          —
        </Text>
      )}
      {submittedAt && hasScore && (
        <Text fontSize="xs" color="gray.500" mt={1}>
          Submitted {formatSubmittedAt(submittedAt)}
        </Text>
      )}
    </Box>
  )
}
